import { formatEquipmentLabelFromCompanySettings } from '../../equipment/equipment.helpers';

export default {};

/**
 * Normalizes an equipment record into a resource row.
 * The default equipment type is not shown as a subtitle.
 */
export const toEquipmentRow = (equipment, { equipmentTypeMap = {}, settings } = {}) => {
  const equipmentType = equipmentTypeMap[equipment.equipmentTypeId];
  return {
    ...equipment,
    name: formatEquipmentLabelFromCompanySettings({
      name: equipment.name,
      code: equipment.code,
      settings,
    }),
    subtitle: equipmentType && !equipmentType.isDefault ? equipmentType.name : undefined,
    divisionIds: equipment.divisionIds ?? [],
  };
};
